import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { user, booting } = useAuth();
  const location = useLocation();

  if (booting || user === null) {
    return (
      <div className="min-h-screen bg-[#F4F1EB] flex items-center justify-center text-[#3A435E]">
        …
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (adminOnly && user.role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default ProtectedRoute;
